var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3V7.5H5.25",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6325 11.2498C3.1188 12.6301 4.0405 13.815 5.25874 14.6259C6.47698 15.4368 7.92576 15.8298 9.38679 15.7457C10.8478 15.6616 12.2419 15.105 13.3591 14.1597C14.4763 13.2143 15.2559 11.9316 15.5807 10.5046C15.9054 9.07765 15.7576 7.58381 15.1595 6.24816C14.5614 4.91252 13.5454 3.80744 12.2646 3.09941C10.9839 2.39139 9.50768 2.11879 8.05851 2.32268C6.60934 2.52657 5.26568 3.19591 4.23 4.22984L0.75 7.49984",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6V9L11.5 11.5",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.40d9866bc694ee5342ef31509a184715.svg";
export { ForwardRef as ReactComponent };